module.exports = __webpack_public_path__ + "static/media/user-shield.198d3998.svg";